import { CafeWithAmenities, WorkTier } from "@/types/cafe";

// Stock images for cafes without user photos - coffee drinks, work scenes, matcha, and pastries
// These are clearly "product/lifestyle" photos that won't be mistaken for actual cafe interiors
// Exported so admins can browse and select from these options
export const STOCK_IMAGES = [
  // Coffee drinks - latte art and cappuccinos (18 images)
  "https://images.unsplash.com/photo-1541167760496-9fa6c42d0b5b?w=800&q=80", // Latte art heart
  "https://images.unsplash.com/photo-1534778101976-62847782c213?w=800&q=80", // Cappuccino art
  "https://images.unsplash.com/photo-1485808191679-5f86510681a2?w=800&q=80", // Beautiful latte
  "https://images.unsplash.com/photo-1572442388796-11668a67e53d?w=800&q=80", // Latte rosetta
  "https://images.unsplash.com/photo-1461023058943-07fcbe16d735?w=800&q=80", // Pour over coffee
  "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=800&q=80", // Coffee cup close-up
  "https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd?w=800&q=80", // Espresso shot
  "https://images.unsplash.com/photo-1511920170033-f8396924c348?w=800&q=80", // Latte with foam
  "https://images.unsplash.com/photo-1517701550927-30cf4ba1dba5?w=800&q=80", // Coffee tulip art
  "https://images.unsplash.com/photo-1559496417-e7f25cb247f3?w=800&q=80", // Creamy cappuccino
  "https://images.unsplash.com/photo-1521302080334-4bebac2763a6?w=800&q=80", // Latte leaf pattern
  "https://images.unsplash.com/photo-1504630083234-14187a9df0f5?w=800&q=80", // Flat white art
  "https://images.unsplash.com/photo-1497935586351-b67a49e012bf?w=800&q=80", // Cold brew
  "https://images.unsplash.com/photo-1551024709-8f23befc6f87?w=800&q=80", // Iced coffee
  "https://images.unsplash.com/photo-1509042239860-f550ce710b93?w=800&q=80", // Coffee art overhead
  "https://images.unsplash.com/photo-1442512595331-e89e73853f31?w=800&q=80", // Minimalist coffee
  "https://images.unsplash.com/photo-1504753793650-d4a2b783c15e?w=800&q=80", // Drip coffee
  "https://images.unsplash.com/photo-1507133750040-4a8f57021571?w=800&q=80", // Espresso pour

  // Matcha drinks (12 images)
  "https://images.unsplash.com/photo-1515823064-d6e0c04616a7?w=800&q=80", // Matcha latte
  "https://images.unsplash.com/photo-1536256263959-770b48d82b0a?w=800&q=80", // Vibrant matcha
  "https://images.unsplash.com/photo-1582793988951-9aed5509eb97?w=800&q=80", // Iced matcha
  "https://images.unsplash.com/photo-1571934811356-5cc061b6821f?w=800&q=80", // Matcha art
  "https://images.unsplash.com/photo-1545696563-55f7e51f2a88?w=800&q=80", // Matcha with whisk
  "https://images.unsplash.com/photo-1558160074-4d7d8bdf4256?w=800&q=80", // Green tea latte
  "https://images.unsplash.com/photo-1576092768241-dec231879fc3?w=800&q=80", // Matcha powder prep
  "https://images.unsplash.com/photo-1564890369478-c89ca6d9cde9?w=800&q=80", // Matcha latte art
  "https://images.unsplash.com/photo-1560713781-d00035f98b09?w=800&q=80", // Layered matcha latte
  "https://images.unsplash.com/photo-1579888944880-d98341245702?w=800&q=80", // Hot matcha drink
  "https://images.unsplash.com/photo-1618424181497-157f25b6ddd5?w=800&q=80", // Matcha in bowl
  "https://images.unsplash.com/photo-1583778176476-4a8b02a64c01?w=800&q=80", // Creamy matcha

  // Coffee with pastry - cafe context (6 images)
  "https://images.unsplash.com/photo-1445116572660-236099ec97a0?w=800&q=80", // Coffee and croissant cafe table
  "https://images.unsplash.com/photo-1509785307050-d4066910ec1e?w=800&q=80", // Latte with pastry
  "https://images.unsplash.com/photo-1600093463592-8e36ae95ef56?w=800&q=80", // Cappuccino and cake slice
  "https://images.unsplash.com/photo-1498804103079-a6351b050096?w=800&q=80", // Coffee and croissant
  "https://images.unsplash.com/photo-1481391032119-d89fee407e44?w=800&q=80", // Espresso and pastry
  "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=800&q=80", // Coffee and pastry plate

  // Specialty coffee drinks (6 images)
  "https://images.unsplash.com/photo-1512568400610-62da28bc8a13?w=800&q=80", // Coffee beans cup
  "https://images.unsplash.com/photo-1514066558159-fc8c588e2e94?w=800&q=80", // Mocha art
  "https://images.unsplash.com/photo-1453614512568-c4024d13c247?w=800&q=80", // Americano
  "https://images.unsplash.com/photo-1570968915860-54d5c301fa9f?w=800&q=80", // V60 pour over
  "https://images.unsplash.com/photo-1594631252845-29fc4cc8cde9?w=800&q=80", // Cortado
  "https://images.unsplash.com/photo-1587734195503-904fca47e0e9?w=800&q=80", // Affogato
];

// Generate a consistent stock image index from cafe id
function getStockImageIndex(cafeId: string): number {
  let hash = 0;
  for (let i = 0; i < cafeId.length; i++) {
    const char = cafeId.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return Math.abs(hash) % STOCK_IMAGES.length;
}

// Get the stock image URL for a cafe
export function getStockImage(cafeId: string): string {
  const index = getStockImageIndex(cafeId);
  return STOCK_IMAGES[index];
}

// Get the best available image URL for a cafe
// Priority: 1) User-uploaded cover, 2) Selected placeholder_index, 3) Random stock image based on id
export function getCafeImageUrl(cafe: CafeWithAmenities | { id: string; cover_image_url?: string | null; placeholder_index?: number | null }): string | null {
  // If there's an existing cover_image_url, use it
  if (cafe.cover_image_url) {
    return cafe.cover_image_url;
  }
  
  // If admin selected a specific placeholder, use that (1-indexed)
  if (cafe.placeholder_index && cafe.placeholder_index >= 1 && cafe.placeholder_index <= STOCK_IMAGES.length) {
    return STOCK_IMAGES[cafe.placeholder_index - 1];
  }
  
  // Otherwise return deterministic stock image based on id
  return getStockImage(cafe.id);
}

/**
 * The image to DISPLAY for a cafe, or null when it has none of its own.
 *
 * Deliberately separate from `getCafeImageUrl` above, which keeps its stock
 * fallback because it also feeds the JSON-LD structured data on the cafe detail
 * page. Returning null there would strip the image from the schema.org markup
 * and cost real search presence, so that function is left exactly as it was.
 *
 * This one is for pixels a person looks at. Priority:
 *   1. the cafe's own cover photo
 *   2. an admin chosen `placeholder_index`, which is a deliberate editorial pick
 *   3. null, meaning "render CafePhotoPlaceholder"
 *
 * The random hash into 42 stock coffee photos is gone from the display path.
 * See CafePhotoPlaceholder for why.
 */
export function getCafeDisplayImageUrl(
  cafe: { cover_image_url?: string | null; placeholder_index?: number | null },
): string | null {
  if (cafe.cover_image_url) return cafe.cover_image_url;
  if (
    cafe.placeholder_index &&
    cafe.placeholder_index >= 1 &&
    cafe.placeholder_index <= STOCK_IMAGES.length
  ) {
    return STOCK_IMAGES[cafe.placeholder_index - 1];
  }
  return null;
}

// Check if cafe has a real image (not stock)
export function hasRealImage(cafe: { cover_image_url?: string | null }): boolean {
  return !!cafe.cover_image_url;
}

// Get tier-based gradient fallback class (for when no image should be shown)
export function getTierGradient(tier: WorkTier): string {
  const gradients: Record<WorkTier, string> = {
    settle_in: "from-sage/90 via-sage/80 to-sage/60",
    get_comfy: "from-honey/90 via-honey/80 to-honey/60",
    quick_cup: "from-terracotta/90 via-terracotta/80 to-terracotta/60",
    just_coffee: "from-slate/90 via-slate/80 to-slate/60",
  };
  return gradients[tier] || gradients.just_coffee;
}

/**
 * Distributes stock images across a list of cafes ensuring no repeats within a 3-item window.
 * Cafes with user photos or admin-set images are skipped (they don't need stock images).
 * 
 * @param cafes - Array of cafes in display order
 * @param userPhotoMap - Map of cafe_id -> user photo URL (cafes with photos are excluded from distribution)
 * @returns Map of cafe_id -> distributed stock image URL
 */
export function distributeStockImages(
  cafes: Array<{ id: string; cover_image_url?: string | null; placeholder_index?: number | null }>,
  userPhotoMap?: Map<string, string>
): Map<string, string> {
  const result = new Map<string, string>();
  const recentlyUsed: string[] = []; // Track last 3 stock images used
  const WINDOW_SIZE = 3;
  
  for (const cafe of cafes) {
    // Skip cafes with user photos or admin cover images
    if (userPhotoMap?.has(cafe.id) || cafe.cover_image_url) {
      continue;
    }
    
    // If admin selected a specific placeholder, use that
    if (cafe.placeholder_index && cafe.placeholder_index >= 1 && cafe.placeholder_index <= STOCK_IMAGES.length) {
      const stockUrl = STOCK_IMAGES[cafe.placeholder_index - 1];
      result.set(cafe.id, stockUrl);
      recentlyUsed.push(stockUrl);
      if (recentlyUsed.length > WINDOW_SIZE) recentlyUsed.shift();
      continue;
    }
    
    // Get the preferred stock image based on cafe id hash
    const preferredIndex = getStockImageIndex(cafe.id);
    let selectedUrl = STOCK_IMAGES[preferredIndex];
    
    // If this image was recently used, find an alternative
    if (recentlyUsed.includes(selectedUrl)) {
      // Try to find an unused image, starting from the preferred index
      let found = false;
      for (let offset = 1; offset < STOCK_IMAGES.length; offset++) {
        const altIndex = (preferredIndex + offset) % STOCK_IMAGES.length;
        const altUrl = STOCK_IMAGES[altIndex];
        if (!recentlyUsed.includes(altUrl)) {
          selectedUrl = altUrl;
          found = true;
          break;
        }
      }
      // If all images are in recent window (shouldn't happen with 44+ images), just use preferred
      if (!found) {
        selectedUrl = STOCK_IMAGES[preferredIndex];
      }
    }
    
    result.set(cafe.id, selectedUrl);
    recentlyUsed.push(selectedUrl);
    if (recentlyUsed.length > WINDOW_SIZE) recentlyUsed.shift();
  }
  
  return result;
}
